export const CREDIT_CARDS_ICONS_PATH = 'assets/images/credit-card/';
export const VISA_ICON_PATH = `${CREDIT_CARDS_ICONS_PATH}visa.svg`;
export const MASTER_CARD_ICON_PATH = `${CREDIT_CARDS_ICONS_PATH}master-card.svg`;
